import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  fetchAlarms, 
  toggleAlarm, 
  deleteAlarm,
  fetchAlarmNotifications
} from '../../actions/alarms';
import AlarmCard from '../../components/Card/Server/AlarmCard';
import { Modal, Empty, Spin } from 'antd';
import { Bell, Siren } from 'lucide-react';

const AlarmsPage = () => {
  const dispatch = useDispatch();
  const { alarms, loading } = useSelector(state => state.alarms);
  const [selectedAlarm, setSelectedAlarm] = useState(null);

  useEffect(() => {
    dispatch(fetchAlarms());
  }, [dispatch]);

  const handleToggleAlarm = (alarmId, isActive) => {
    dispatch(toggleAlarm(alarmId, !isActive));
  };

  const handleDeleteAlarm = (alarmId) => {
    dispatch(deleteAlarm(alarmId));
  };

  const handleViewNotifications = (alarmId) => {
    setSelectedAlarm(alarmId);
    dispatch(fetchAlarmNotifications(alarmId));
  };

  return (
    <div className="p-6 bg-transparent">
      <div className="flex items-center mb-6">
        <Siren className="h-6 w-6 mr-2" />
        <h1 className="text-2xl font-bold">My Alarms</h1>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Spin size="large" />
        </div>
      ) : alarms && alarms.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {alarms.map(alarm => (
            <AlarmCard
              key={alarm.alarmId}
              alarm={alarm}
              onClick={() => console.log('View alarm details')}
              onDelete={() => handleDeleteAlarm(alarm.alarmId)}
              onToggle={() => handleToggleAlarm(alarm.alarmId, alarm.isActive)}
              onViewNotifications={() => handleViewNotifications(alarm.alarmId)}
            />
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center h-64">
          <Empty 
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            imageStyle={{ height: 80 }}
            description={
              <span className="text-gray-500 text-lg">
                No alarms configured. Alarms will appear here when they are created.
              </span>
            }
          />
        </div>
      )}

      {/* Notifications Modal */}
      <Modal
        title={
          <div className="flex items-center">
            <Bell className="w-5 h-5 mr-2 text-blue-500" />
            <span>Alarm Notifications</span>
          </div>
        }
        open={!!selectedAlarm}
        onCancel={() => setSelectedAlarm(null)}
        footer={null}
        width={600}
      >
        {alarms && selectedAlarm && alarms.find(a => a.alarmId === selectedAlarm)?.notifications?.length ? (
          <div className="max-h-[400px] overflow-y-auto">
            {alarms.find(a => a.alarmId === selectedAlarm).notifications.map(notification => (
              <div 
                key={notification.notificationId} 
                className="p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-medium text-gray-900">{notification.title}</h4>
                    <p className="text-sm text-gray-600 mt-1">{notification.message}</p>
                  </div>
                  <span className="text-xs text-gray-400 whitespace-nowrap">
                    {new Date(notification.timestamp).toLocaleString()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Empty 
            description="No notifications for this alarm" 
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        )}
      </Modal>
    </div>
  );
};

export default AlarmsPage;